import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import CustomAppBar from './components/CustomAppBar';
import BottomNavigationBar from './components/BottomNavigationBar';

const AppLayout = () => {
  const location = useLocation();

  return (
      <Box sx={{ 
        backgroundColor: 'var(--bg-color)',
        color: '#fff',
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
      }}>
        {/* App Bar */}
        <CustomAppBar />

        {/* Main Content */}
        <Box sx={{ 
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          marginTop: '64px', // Offset for App Bar
          marginBottom: 'calc(56px + env(safe-area-inset-bottom))', // Offset for Bottom Navigation + iOS safe area
          overflowY: 'hidden',
          overflowX: 'hidden',
          maxHeight: 'calc(100dvh - 64px - 56px - env(safe-area-inset-bottom))', // Calculate available height
          '& > *': {
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
          },
        }}>
          <Outlet />
        </Box>

        {/* Bottom Navigation */}
        <BottomNavigationBar currentPage={location.pathname} />
      </Box>
  );
};

export default AppLayout;